import moment from 'moment';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { useQuery } from '@apollo/client';
import { GET_HISTORIAL_PAQUETE } from '../../../Querys/prestaciones/querys';
import { PaqueteBitacora } from '../../../interfaces/Prestaciones.interface';
import PackageHistoryTimeline from './PackageHistoryTimeline';
import { DownloadExcel } from '../../../helpers/DownloadExcel';
import '../../Collaborator/History/History.css';

interface PackageHistoryModalProps {
  open: boolean;
  onClose: () => void;
  packageData: any;
}

const PackageHistoryModal = ({ open, onClose, packageData }: PackageHistoryModalProps) => {
  const { data, loading, error } = useQuery(GET_HISTORIAL_PAQUETE, {
    variables: { idPaquete: packageData?.id },
    skip: !packageData,
    fetchPolicy: 'no-cache',
  });

  const events: PaqueteBitacora[] = data?.GET_HISTORIAL_PAQUETE ?? [];

  const tipoLabel: Record<string, string> = {
    CREACION: 'Creación',
    EDICION: 'Edición',
    ACTIVACION: 'Activación',
    DESACTIVACION: 'Desactivación',
    ELIMINACION: 'Eliminación',
  };

  // Parseo en UTC para que la fecha exportada coincida con el calendario almacenado
  // (evita el corrimiento de un día en usuarios de México). Igual que los timelines.
  const formatFechaUtc = (fecha: string) => {
    const num = Number(fecha);
    const m = !isNaN(num) && String(fecha).trim() !== '' ? moment.utc(num) : moment.utc(fecha);
    return m.isValid() ? m.format('DD/MM/YYYY') : '';
  };

  const handleExport = () => {
    const header = ['Tipo de movimiento', 'Descripción', 'Fecha', 'Realizado por'];
    const body = events.map((e) => [
      tipoLabel[e.tipoMovimiento] ?? e.tipoMovimiento,
      e.descripcion ?? '',
      formatFechaUtc(e.fecha),
      e.nombreUsuario,
    ]);
    DownloadExcel(`Historial_${packageData?.nombre ?? 'paquete'}`, 'Historial', header, body);
  };

  return (
    <Dialog
      aria-labelledby="package-history-dialog"
      className="history-modal"
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <h2 id="form-dialog-title" className="text-center" style={{ marginTop: 20 }}>
          Historial de cambios
        </h2>
        <h3 id="form-dialog-subtitle">{packageData?.nombre ?? ''}</h3>
        <span id="closemodalx" onClick={onClose}>
          <img alt="close" src="/assets/svg/CloseM.svg" />
        </span>
      </DialogTitle>

      <DialogContent>
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}>
            <CircularProgress style={{ color: '#FABB00' }} />
          </div>
        )}
        {!loading && error && (
          <Alert severity="error" style={{ margin: '16px 0' }}>
            No se pudo cargar el historial. Intenta de nuevo más tarde.
          </Alert>
        )}
        {!loading && !error && events.length === 0 && (
          <Alert severity="info" style={{ margin: '16px 0' }}>
            No hay cambios registrados para este paquete.
          </Alert>
        )}
        {!loading && !error && events.length > 0 && (
          <PackageHistoryTimeline events={events} />
        )}
      </DialogContent>

      <MuiDialogActions>
        {events.length > 0 && (
          <button
            className="buttonSave"
            style={{ marginRight: 8 }}
            onClick={handleExport}
          >
            Exportar Excel
          </button>
        )}
        <button className="btnCancel" onClick={onClose}>
          Cerrar
        </button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default PackageHistoryModal;
